import React from "react";
import { Box, Chip } from "@mui/material";
import { horizontalScroll } from "../home/homeStyles";
import { compareChipSx } from "../compare/compareChromeStyles";
import { BRAND_COLORS } from "../../utils/brandAssets";

const SeasonChipRail = ({ seasons = [], value, onChange }) => {
  if (seasons.length <= 1) return null;

  return (
    <Box
      role="listbox"
      aria-label="Season"
      sx={{ ...horizontalScroll, mb: 2, mx: -0.5, px: 0.5 }}
    >
      {seasons.map((season) => {
        const selected = season === value;
        return (
          <Chip
            key={season}
            label={season}
            clickable
            role="option"
            aria-selected={selected}
            variant={selected ? "filled" : "outlined"}
            onClick={() => onChange?.(season)}
            sx={{
              ...compareChipSx(selected),
              ...(selected && {
                bgcolor: BRAND_COLORS.cyan,
                color: BRAND_COLORS.navy,
                borderColor: BRAND_COLORS.cyan,
                fontWeight: 700,
                "&:hover": {
                  bgcolor: BRAND_COLORS.cyan,
                  color: BRAND_COLORS.navy,
                  borderColor: BRAND_COLORS.cyan,
                },
              }),
            }}
          />
        );
      })}
    </Box>
  );
};

export default SeasonChipRail;
